import { render, staticRenderFns } from "./NewDrugSusceptibility.vue?vue&type=template&id=6a9e8e80&scoped=true"
import script from "./NewDrugSusceptibility.vue?vue&type=script&lang=js"
export * from "./NewDrugSusceptibility.vue?vue&type=script&lang=js"
import style0 from "./NewDrugSusceptibility.vue?vue&type=style&index=0&id=6a9e8e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e8e80",
  null
  
)

export default component.exports